module.exports = __webpack_public_path__ + "static/media/02_propose_b.8502e2b6.mp4";